<template>
  <b-field
    :label="$translate(filterInfo.label) | capitalize"
    label-position="on-border"
    expanded
  >
    <b-select
      expanded
      v-model="filterInfo.filterValue"
      @input="searchData()"
      :disabled="disabledbool"
      size="is-small"
    >
      <option
        v-for="option in filterInfo.options"
        :value="option.name == undefined ? null : option.name"
        :key="option.name"
      >
        <template v-if="option.name != undefined">{{
          $translate(option.name.toString()) | capitalize
        }}</template>
        <template v-else>
          {{ $translate("no_value") }}
        </template>
      </option>
    </b-select>
  </b-field>
</template>

<script>
export default {
  name: "filterSelect",
  model: {
    prop: "filterInfo",
    event: "change",
  },
  props: ["disabledbool", "filterInfo"],
  methods: {
    searchData() {
      this.$emit("change", this.filterInfo);
    },
  },
};
</script>
